var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 2.59377V4.71017H7.21875C6.13184 4.71017 5.25 5.59201 5.25 6.67892V10.3129C5.25 11.3998 6.13184 12.2817 7.21875 12.2817H11.1562V14.3981C11.1562 16.1453 13.2768 17.0313 14.5154 15.7885L20.4217 9.88635C21.1887 9.11935 21.1887 7.87248 20.4217 7.10138L14.5154 1.19513C13.2809 -0.031235 11.1562 0.842398 11.1562 2.59377ZM19.0312 8.50002L13.125 14.4063V10.317H7.21875V6.68302H13.125V2.59377L19.0312 8.50002ZM3.9375 0.625015H7.38281C7.65352 0.625015 7.875 0.8465 7.875 1.1172V2.10158C7.875 2.37228 7.65352 2.59377 7.38281 2.59377H3.9375C2.85059 2.59377 1.96875 3.4756 1.96875 4.56252V12.4375C1.96875 13.5244 2.85059 14.4063 3.9375 14.4063H7.38281C7.65352 14.4063 7.875 14.6278 7.875 14.8985V15.8828C7.875 16.1535 7.65352 16.375 7.38281 16.375H3.9375C1.76367 16.375 0 14.6113 0 12.4375V4.56252C0 2.38869 1.76367 0.625015 3.9375 0.625015Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c80bf52e.svg";
export { ForwardRef as ReactComponent };